import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { GetInformationsService } from './api-services/get-informations.service';
import { RegistInformationsService } from './api-services/regist-informations.service';
import { GetInfomationService } from '../../kymw10/kymw1002/api-services/get-infomation.service';
import { KYMW9300Component } from './kymw9300.component';

/**
 * お知らせ編集画面 モジュール設定クラス
 *
 * @export KYMW9300Module
 * @class KYMW9300Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AppCommonsModule,
    PlessSharedModule,
  ],
  declarations: [
    KYMW9300Component,
  ],
  providers: [
    GetInformationsService,
    RegistInformationsService,
    GetInfomationService,
  ],
})
export class KYMW9300Module {

}
